var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArgosTeamsPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.62 45.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #89397d;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.66,14.41c-.37-2.23-2.3-3.86-4.56-3.86h-2.6c-2.26,0-4.19,1.63-4.56,3.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.51,7.86c0,1.49-1.21,2.7-2.7,2.7s-2.7-1.21-2.7-2.7,1.21-2.7,2.7-2.7,2.7,1.21,2.7,2.7Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.81,
    cy: 9.05,
    r: 8.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.9,40.62c-.37-2.23-2.3-3.86-4.56-3.86h-2.6c-2.26,0-4.19,1.63-4.56,3.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.75,34.06c0,1.49-1.21,2.7-2.7,2.7s-2.7-1.21-2.7-2.7,1.21-2.7,2.7-2.7,2.7,1.21,2.7,2.7Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 9.05,
    cy: 35.25,
    r: 8.05,
    transform: "translate(-27.2 38.54) rotate(-80.78)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.42,40.62c-.37-2.23-2.3-3.86-4.56-3.86h-2.6c-2.26,0-4.19,1.63-4.56,3.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.26,34.06c0,1.49-1.21,2.7-2.7,2.7s-2.7-1.21-2.7-2.7,1.21-2.7,2.7-2.7,2.7,1.21,2.7,2.7Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40.57,
    cy: 35.25,
    r: 8.05,
    transform: "translate(-3.06 66.64) rotate(-76.72)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.46,43.58c-2.06.8-4.31,1.23-6.66,1.23-3.96,0-7.62-1.24-10.63-3.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.06,11.68c4.39,3.38,7.23,8.69,7.23,14.66,0,.42-.01.83-.04,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.65,22.91c1.09-5.82,4.91-10.67,10.07-13.19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgosTeamsPurple);
export default __webpack_public_path__ + "static/media/Argos - Teams - Purple.177ad9607e1a104813010e06b5e429d5.svg";
export { ForwardRef as ReactComponent };